module.exports = __webpack_public_path__ + "img/fondo-QEUF.cfedbe5d.jpg";